export default function splitWhitespace (s) {
  return s.split(' ');
}
